import React, { useState, useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import MobileDashboard from "./pages/MobileDashboard";
import LoginPage from "./pages/LoginPage";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    fetch("/reservations/api/auth/me/", { credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (data.authenticated) setUser(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="min-h-screen bg-black flex items-center justify-center text-[#c1b428]">
      Učitavanje...
    </div>
  );

  if (!user) return <LoginPage onLogin={(data) => setUser(data)} />;

  return (
    <div className="App">
      {isMobile
        ? <MobileDashboard user={user} onLogout={() => setUser(null)} />
        : <Dashboard user={user} onLogout={() => setUser(null)} />
      }
    </div>
  );
}

export default App;